"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zIndices = void 0;
var zIndices_1 = __importDefault(require("../tokens/zIndices"));
exports.zIndices = zIndices_1.default;
//# sourceMappingURL=zIndices.js.map